"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableCell = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var TableCell = function TableCell(props) {
  var children = props.children,
      colSpan = props.colSpan,
      classNames = props.classNames,
      onClick = props.onClick;
  var isClickable = !_lodash.default.isUndefined(onClick); // ADA compliant - allow an enter key to act like a click.

  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  var handleClick = function handleClick() {
    if (!_lodash.default.isUndefined(onClick)) {
      onClick();
    }
  };

  var clickableProps = isClickable ? {
    onClick: handleClick,
    onKeyDown: _handleKeyPress,
    tabIndex: 0,
    role: 'button'
  } : {};
  var tableCellClassNames = {
    'table-cell': true,
    'table-cell--clickable': isClickable
  };
  return /*#__PURE__*/_react.default.createElement("td", _extends({
    className: (0, _classnames.default)(tableCellClassNames, classNames),
    colSpan: colSpan,
    role: _lodash.default.isUndefined(onClick) ? 'cell' : 'button'
  }, clickableProps), children);
};

exports.TableCell = TableCell;
TableCell.propTypes = {
  onClick: _propTypes.default.func
};
var defaultProps = {
  colSpan: 1,
  classNames: {},
  children: null
};
TableCell.defaultProps = defaultProps;
var _default = TableCell;
exports.default = _default;